enum AppStorageKey {
  AdminAuthToken = 'x-admin-auth-token',
}

export default AppStorageKey;
